import { DynamicFormField } from '../form/formulary';
import { Validators } from '@angular/forms';

export const BaseConnection = {
  soap: [
    { key: 'wsdl', label: 'connections.fields.wsdl', type: 'text', required: true, icon: 'globe' },
    {
      key: 'method',
      label: 'connections.fields.soapMethod',
      type: 'text',
      required: true,
      icon: 'cog',
    },
    { key: 'headers', label: 'connections.fields.headers', type: 'textarea', icon: 'code' },
    {
      key: 'body',
      label: 'connections.fields.xmlBody',
      type: 'textarea',
      required: true,
      icon: 'file',
    },
  ],
  ftp: [
    {
      key: 'name',
      label: 'connections.fields.name',
      type: 'text',
      required: true,
      icon: 'paperclip',
      validators: [Validators.minLength(3)],
    },
    {
      key: 'host',
      label: 'connections.fields.host',
      type: 'text',
      required: true,
      icon: 'globe',
      validators: [
        Validators.pattern(
          /(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})(\.[a-zA-Z0-9]{2,})?/,
        ),
      ],
    },
    {
      key: 'port',
      label: 'connections.fields.port',
      type: 'number',
      required: true,
      icon: 'hashtag',
    },
    { key: 'user', label: 'connections.fields.user', type: 'text', required: true, icon: 'user' },
    {
      key: 'password',
      label: 'connections.fields.password',
      type: 'password',
      required: true,
      icon: 'lock',
    },
  ],
  sftp: [
    {
      key: 'name',
      label: 'connections.fields.name',
      type: 'text',
      required: true,
      icon: 'paperclip',
      validators: [Validators.minLength(3)],
    },
    {
      key: 'host',
      label: 'connections.fields.host',
      type: 'text',
      icon: 'globe',
      required: true,
      validators: [
        Validators.pattern(
          /(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})(\.[a-zA-Z0-9]{2,})?/,
        ),
      ],
    },
    {
      key: 'port',
      label: 'connections.fields.port',
      type: 'number',
      icon: 'hashtag',
      required: true,
    },
    {
      key: 'username',
      label: 'connections.fields.user',
      type: 'text',
      icon: 'user',
      required: true,
    },
    {
      key: 'password',
      label: 'connections.fields.password',
      type: 'password',
      icon: 'lock',
      required: false,
    },
  ],
  rest: [
    {
      key: 'base_url',
      label: 'connections.fields.baseUrl',
      type: 'text',
      required: true,
      icon: 'globe',
      validators: [
        Validators.pattern(
          /(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})(\.[a-zA-Z0-9]{2,})?/,
        ),
      ],
    },
    {
      key: 'auth_type',
      label: 'connections.fields.authType',
      type: 'text',
      required: false,
      icon: 'shield',
    },
    {
      key: 'auth_api_key_header_name',
      label: 'connections.fields.apiKeyHeaderName',
      type: 'text',
      required: false,
      icon: 'tag',
    },
    {
      key: 'auth_api_key_header_value',
      label: 'connections.fields.apiKeyHeaderValue',
      type: 'text',
      required: false,
      icon: 'key',
    },
  ],
  restlet: [
    {
      key: 'token_id',
      label: 'connections.fields.tokenId',
      type: 'text',
      required: true,
      icon: 'id-card',
    },
    {
      key: 'account_id',
      label: 'connections.fields.accountId',
      type: 'text',
      required: true,
      icon: 'building',
    },
    {
      key: 'restlet_url',
      label: 'connections.fields.restletUrl',
      type: 'text',
      required: true,
      icon: 'globe',
      validators: [
        Validators.pattern(
          /(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})(\.[a-zA-Z0-9]{2,})?/,
        ),
      ],
    },
    {
      key: 'consumer_key',
      label: 'connections.fields.consumerKey',
      type: 'text',
      required: true,
      icon: 'key',
    },
    {
      key: 'token_secret',
      label: 'connections.fields.tokenSecret',
      type: 'password',
      required: true,
      icon: 'lock',
    },
    {
      key: 'consumer_secret',
      label: 'connections.fields.consumerSecret',
      type: 'password',
      required: true,
      icon: 'lock',
    },
  ],
  postgresql: [
    {
      key: 'host',
      label: 'connections.fields.hostName',
      type: 'text',
      required: true,
      icon: 'server',
    },
    {
      key: 'port',
      label: 'connections.fields.port',
      type: 'number',
      required: true,
      icon: 'hashtag',
      validators: [Validators.min(1), Validators.max(65535)],
    },
    {
      key: 'user',
      label: 'connections.fields.userName',
      type: 'text',
      required: true,
      icon: 'user',
    },
    {
      key: 'dbname',
      label: 'connections.fields.databaseName',
      type: 'text',
      required: true,
      icon: 'database',
    },
    {
      key: 'password',
      label: 'connections.fields.password',
      type: 'password',
      required: true,
      icon: 'lock',
    },
    {
      key: 'asdf',
      label: 'connections.fields.extraField',
      type: 'text',
      required: false,
      icon: 'info',
    },
  ],
  netsuite: [
    {
      key: 'name',
      label: 'connections.fields.name',
      type: 'text',
      required: true,
      icon: 'paperclip',
      validators: [Validators.minLength(3)],
    },
    {
      key: 'account',
      label: 'connections.fields.account',
      type: 'text',
      required: true,
      icon: 'building',
      validators: [],
    },
    {
      key: 'consumer_key',
      label: 'connections.fields.consumerKey',
      type: 'text',
      required: true,
      icon: 'key',
      validators: [Validators.minLength(1)],
    },
    {
      key: 'consumer_secret',
      label: 'connections.fields.consumerSecret',
      type: 'password',
      required: true,
      icon: 'lock',
      validators: [Validators.minLength(1)],
    },
    {
      key: 'token_key',
      label: 'connections.fields.tokenKey',
      type: 'text',
      required: true,
      icon: 'key',
      validators: [Validators.minLength(1)],
    },
    {
      key: 'token_secret',
      label: 'connections.fields.tokenSecret',
      type: 'password',
      required: true,
      icon: 'lock',
      validators: [Validators.minLength(1)],
    },
    {
      key: 'realm',
      label: 'connections.fields.realm',
      type: 'text',
      required: true,
      icon: 'globe',
      validators: [Validators.minLength(3)],
    },
    {
      key: 'script_id',
      label: 'connections.fields.scriptId',
      type: 'text',
      required: true,
      icon: 'code',
      validators: [Validators.minLength(3)],
    },
    {
      key: 'deploy_id',
      label: 'connections.fields.deployId',
      type: 'text',
      required: true,
      icon: 'cog',
      validators: [Validators.minLength(1)],
    },
  ],
} satisfies Record<string, DynamicFormField[]>;

export type ConnectionType = keyof typeof BaseConnection;
